import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemCms} from '../CM/FormChooseCm.jsx'
import Model from './ModelUc.mjs'

export const FormItemReqNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="reqNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemSfName = props => (
    <FormItemBizProp
        Model={Model}
        prop="sfName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemSfNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="sfNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseUc(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemCms />
            <FormItemSfNo />
            <FormItemSfName />
            <FormItemReqNo />
        </FormChooseDesign>
    )
}
